import {ready} from "./ready";
import {startWhichSizeVideo, utils, vh} from "./utils";
import {openPopupById} from "./popups";
import {goToByScroll} from "./go-to-by-scroll";
import {bindLinkToItem} from "./bind-link-to-item";
import {inputToToggle} from "./custom-checkbox-radio";
import {dragOverflow} from "./drag-overflow";

ready(() => {

	// Initialize a new Lenis instance for smooth scrolling
	const lenis = new Lenis();

	// Listen for the 'scroll' event and log the event data to the console
	/*lenis.on('scroll', (e) => {
		console.log(e);
	});*/

	// Synchronize Lenis scrolling with GSAP's ScrollTrigger plugin
	lenis.on('scroll', ScrollTrigger.update);

	// Add Lenis's requestAnimationFrame (raf) method to GSAP's ticker
	// This ensures Lenis's smooth scroll animation updates on each GSAP tick
	gsap.ticker.add((time) => {
		lenis.raf(time * 1000); // Convert time from seconds to milliseconds
	});

	// Disable lag smoothing in GSAP to prevent any delay in scroll animations
	gsap.ticker.lagSmoothing(0);

	gsap.registerPlugin(ScrollTrigger);

	const mm = gsap.matchMedia();

	const breakpointMd = window.matchMedia('(min-width: 768px)');
	const breakpointLg = window.matchMedia('(min-width: 992px)');
	const breakpointXl = window.matchMedia('(min-width: 1440px)');


	/**
	 * Load the videos matching the media queries
	 */
	startWhichSizeVideo(document.body);


	/**
	 * Add close toggle with label to sub menus
	 */
	document.querySelectorAll('#site-navigation .menu-item-has-children').forEach(function (menuItem) {
		const navMenu     = document.getElementById('menu-navigazione');
		let menuItemLabel = menuItem.querySelector('a').textContent;
		let closeMenuItem = document.createElement('li');
		closeMenuItem.classList.add('close-sub-menu', 'menu-item');
		closeMenuItem.textContent = menuItemLabel;

		menuItem.querySelector('.sub-menu').prepend(closeMenuItem);

		closeMenuItem.addEventListener('click', function () {
			menuItem.classList.remove('open');
			navMenu.parentNode.classList.remove('sub-menu-open');
			navMenu.parentNode.removeAttribute('data-menu-open');
		});
	});


	/**
	 * Toggle sub menu when clicking on the whole anchor
	 */
	document.querySelectorAll('.menu-item-has-children > a').forEach((el) => {

		el.addEventListener('click', function (e) {
			e.preventDefault();
			e.stopPropagation();

			const toggleMenuItem = el.querySelector('.toggle_menu_item');

			toggleMenuItem.click();
		});
	});


	/**
	 * Breadcrumbs drag on hover
	 */
	dragOverflow({
		wrapper:    document.querySelector('.breadcrumbs'),
		inner:      '.breadcrumbs__inner',
		mouseHover: true,
		reset:      true,
	});

	setTimeout(function () {
		dragOverflow({
			wrapper: document.querySelector('.scroll-wrapper:not(.breadcrumbs)'),
			inner:   ':scope > div',
		});
	}, 400);


	/**
	 * Pause autoplay videos and show button for use who prefer reduced motion
	 * @type {boolean}
	 */
	let reducedMotion  = matchMedia('(prefers-reduced-motion)').matches;
	let autoplayVideos = document.querySelectorAll('video[muted][autoplay]');

	if (reducedMotion)
	{
		for (let video of autoplayVideos)
		{
			const section = video.closest('div');

			video.pause();
			section.classList.add('show-buttons')
		}
	}


	/**
	 * Play/pause videos
	 * @type {NodeListOf<Element>}
	 */
	const mediaBlocks = document.querySelectorAll('.media');

	mediaBlocks.forEach((section) => {
		const video = section.querySelector('video');
		const btn   = section.querySelector('.media__toggle');

		if (!video || !btn)
		{
			return;
		}

		const playLabel  = btn.querySelector('.sr-play');
		const pauseLabel = btn.querySelector('.sr-pause');

		const syncState = () => {
			const isPlaying = !video.paused && !video.ended;

			// ARIA
			btn.ariaPressed = isPlaying;

			// UI state
			section.classList.toggle('playing', isPlaying);

			// toggle labels
			if (playLabel && pauseLabel)
			{
				playLabel.hidden  = isPlaying;
				pauseLabel.hidden = !isPlaying;
			}
		};

		btn.addEventListener('click', () => {
			if (video.paused || video.ended)
			{
				video.play();

				if (!video.hasAttribute('autoplay'))
				{
					video.setAttribute('controls', 'true');
				}

				section.classList.add('playing');
			}
			else
			{
				video.pause();
				section.classList.remove('playing');
				video.removeAttribute('controls');
			}
		});

		video.addEventListener('pause', function () {
			if (video.readyState !== 4)
			{
				return true;
			}

			// Firefox dispatches the pause event but
			// doesn't set the video to paused
			setTimeout(() => {
				if (video.paused)
				{
					section.classList.remove('playing');
					video.removeAttribute('controls');
					syncState();
				}
			}, 150);
		});

		video.addEventListener('ended', function () {
			section.classList.remove('playing');
			video.removeAttribute('controls');
			video.currentTime = 0; // reset video
			syncState();
		});

		video.addEventListener('play', syncState);

		// initial sync
		syncState();
	});


	/**
	 * Returns groups of consecutive sibling elements
	 * that match the provided CSS selector.
	 *
	 * Only groups with 2 or more elements are returned.
	 *
	 * @param {string} selector - Any valid CSS selector (e.g. '.item', 'div.active')
	 * @param {ParentNode} root - Optional root element to search within (defaults to document)
	 * @returns {HTMLElement[][]} Array of element groups
	 */
	function getConsecutiveGroups(selector, root = document) {
		// Select all matching elements inside the root
		const elements = root.querySelectorAll(selector);

		const groups        = [];
		let currentGroup    = [];
		let previousElement = null;

		for (const el of elements)
		{
			// Check if the current element is immediately after
			// the previous one in the DOM (true sibling adjacency)
			if (previousElement && previousElement.nextElementSibling === el)
			{
				// Same consecutive run → extend the current group
				currentGroup.push(el);
			}
			else
			{
				// Run was broken → store it if it had more than one element
				if (currentGroup.length > 1)
				{
					groups.push(currentGroup);
				}

				// Start a new group with the current element
				currentGroup = [el];
			}

			// Update reference for next iteration
			previousElement = el;
		}

		// After loop ends, check the final group
		if (currentGroup.length > 1)
		{
			groups.push(currentGroup);
		}

		return groups;
	}


	/**
	 * CTA modules animation
	 * @type {unknown[]}
	 */
	const modulesCtaGroups = getConsecutiveGroups(".module-cta");

	modulesCtaGroups.forEach((modulesCta, index) => {
		const lastModuleCta = modulesCta[modulesCta.length - 1];

		modulesCta.forEach((module, index) => {

			// Skip last card (it should scroll normally)
			if (index === modulesCta.length - 1)
			{
				return;
			}

			const nextModule = modulesCta[index + 1];

			// animate opacity and scale with scrub
			gsap.to(module, {
				scale:           0.95,
				opacity:         0,
				transformOrigin: "top center",
				ease:            "none",
				scrollTrigger:   {
					trigger:    module,
					start:      "top 112px",
					endTrigger: nextModule,
					end:        "top 112px",
					scrub:      1,
					//markers:    true
				}
			});

			// pin items on scroll
			ScrollTrigger.create({
				trigger:    module,
				start:      "top 112px",
				endTrigger: lastModuleCta,
				end:        "top 112px",
				pin:        true,
				pinSpacing: false,
				scrub:      false,
				//markers:    true
			});

		});
	});


	/**
	 * GTM tracking: push a "cta_click" dataLayer event when a CTA module's
	 * button is clicked. cta_id comes from the module's data-cta-id attribute
	 * (the module's position on the page); cta_label and cta_url are read
	 * directly from the button itself.
	 */
	document.querySelectorAll('.module-cta[data-cta-id], .module-cta-alpac[data-cta-id]').forEach((module) => {
		const button = module.querySelector('.btn');

		if (!button)
		{
			return;
		}

		button.addEventListener('click', function (e) {
			const label = button.querySelector('.btn__label');

			window.dataLayer = window.dataLayer || [];

			const ctaClickData = {
				event:     'cta_click',
				cta_label: label ? label.textContent.trim() : button.textContent.trim(),
				cta_id:    module.dataset.ctaId,
				cta_url:   button.href,
			};

			// Let modified/new-tab clicks navigate immediately: nothing to delay there.
			const opensInNewContext = button.target === '_blank' || e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1;

			if (opensInNewContext)
			{
				window.dataLayer.push(ctaClickData);
				return;
			}

			// The button navigates the current tab away immediately, which can cut
			// off the dataLayer push/GTM tag firing before it completes. Delay
			// navigation until GTM confirms it processed the event (eventCallback),
			// with a fixed-timeout fallback in case GTM isn't loaded/blocked, so
			// navigation never hangs.
			e.preventDefault();

			let navigated = false;

			const navigate = () => {
				if (navigated)
				{
					return;
				}

				navigated            = true;
				window.location.href = button.href;
			};

			ctaClickData.eventCallback = navigate;
			ctaClickData.eventTimeout  = 2000;

			window.dataLayer.push(ctaClickData);

			setTimeout(navigate, 2000);
		});
	});


	/**
	 * Apre la tabella di .module-dettagli-tecnici__dettagli
	 */
	const moduleDettagliTecniciDettagli = document.querySelector('.module-dettagli-tecnici__dettagli');

	if (moduleDettagliTecniciDettagli !== null)
	{
		const MAX_HEIGHT = 280;

		let moduleDettagliTecniciDettagliHeight = moduleDettagliTecniciDettagli.scrollHeight;
		const moduleDettagliTecniciDettagliBtn  = document.querySelector('.module-dettagli-tecnici__load-more');

		if (moduleDettagliTecniciDettagliHeight >= MAX_HEIGHT)
		{
			moduleDettagliTecniciDettagli.classList.add('limit');
			moduleDettagliTecniciDettagli.style.maxHeight = MAX_HEIGHT + 'px';

			moduleDettagliTecniciDettagliBtn.addEventListener('click', function () {
				moduleDettagliTecniciDettagli.classList.remove('limit');
				moduleDettagliTecniciDettagli.style.maxHeight  = moduleDettagliTecniciDettagliHeight + 'px';
				moduleDettagliTecniciDettagliBtn.style.opacity = 0;

				setTimeout(function () {
					moduleDettagliTecniciDettagliBtn.remove();
				}, 600);
			});
		}
		else
		{
			moduleDettagliTecniciDettagliBtn.remove();
		}

		window.addEventListener('resizeHorizontallyEnd', function () {

			moduleDettagliTecniciDettagliHeight = moduleDettagliTecniciDettagli.scrollHeight;

		});
	}


	/**
	 * Progressive "load more" list with animation + accessibility.
	 *
	 * @param {HTMLElement|null} container
	 * @param {HTMLElement|null} button
	 * @param {number} initialCount
	 * @param {number} moreCount
	 */
	function setupLoadMoreList(container, button, initialCount, moreCount) {
		if (!container || !button)
		{
			return;
		}

		const items = Array.from(container.children);

		if (!items.length)
		{
			button.remove();
			return;
		}

		let visibleCount = Math.max(0, initialCount);
		const step       = Math.max(1, moreCount);

		// Accessibility: connect button to the controlled region
		const containerId = container.id || `list-${Math.random().toString(36).slice(2)}`;
		container.id      = containerId;
		button.setAttribute('aria-controls', containerId);

		function render(animate = false) {
			items.forEach((item, index) => {
				const shouldShow = index < visibleCount;

				// Accessibility: use hidden attribute (removes from screen readers too)
				item.hidden = !shouldShow;

				if (shouldShow && animate)
				{
					item.classList.add('is-revealed');
				}
			});

			// If all items are visible → remove gradient + button
			if (visibleCount >= items.length)
			{
				container.classList.remove('limit');
				button.remove();
			}

			ScrollTrigger.getAll().forEach(t => t.refresh());
		}

		// Initial state
		visibleCount = Math.min(visibleCount, items.length);

		// Add gradient limiter only if needed
		if (visibleCount < items.length)
		{
			container.classList.add('limit');
		}
		else
		{
			button.remove();
		}

		render(false);

		button.addEventListener('click', () => {
			const prevCount = visibleCount;
			visibleCount    = Math.min(visibleCount + step, items.length);

			// Only animate newly revealed items
			items.slice(prevCount, visibleCount).forEach(item => {
				item.classList.remove('is-revealed'); // reset if needed
				// force reflow to restart animation
				void item.offsetWidth;
				item.classList.add('is-revealed');
			});

			render(true);
		});
	}


	// .rivenditori-list__grid pagination is handled by rivenditori-map.js
	// instead of setupLoadMoreList(), since it also needs to combine with
	// the radius/product filters that live in that file.


	const referenzeList    = document.querySelector('.referenze-list__grid');
	const referenzeListBtn = document.querySelector('.referenze-list__load-more');

	setupLoadMoreList(referenzeList, referenzeListBtn, 9, 8);


	/**
	 * Toggle cards
	 * @type {NodeListOf<Element>}
	 */
	const cardToggles = document.querySelectorAll('.card__toggle');

	cardToggles.forEach((btn) => {
		btn.addEventListener('click', () => {
			const card   = btn.closest('.card');
			const panel  = card.querySelector('.card__panel');
			const isOpen = card.classList.toggle('open');

			// Update accessibility state
			btn.ariaExpanded = isOpen;
			panel.ariaHidden = !isOpen;

			btn.querySelector('.sr-open').hidden  = isOpen;
			btn.querySelector('.sr-close').hidden = !isOpen;
		});
	});


	/**
	 * Numbers appear from the bottom animation
	 */
	const numeros = gsap.utils.toArray('.module-numeri')

	numeros.forEach(function (item, i) {

		const innerItem = item.querySelectorAll('.module-numeri__numero div');

		gsap.from(innerItem, {
			y:             '100%',
			ease:          'power4.inOut',
			duration:      1.2,
			stagger:       0.05,
			scrollTrigger: {
				trigger: item,
				start:   'top bottom',
				end:     'bottom bottom',
				once:    true,
				//markers: true
			},
		});
	});


	/**
	 * Index sidebar navigation
	 * @type {Element}
	 */
	const indexSidebar = document.querySelector(".index-sidebar");

	if (indexSidebar !== null)
	{
		const indexSidebarNavLinks = gsap.utils.toArray(".index-sidebar li");
		const sections             = gsap.utils.toArray(".index");


		sections.forEach((section, i) => {
			ScrollTrigger.create({
				trigger:     section,
				endTrigger:  sections[i + 1],
				start:       "top 50%",
				end:         "bottom 50%",
				onEnter:     () => activateIndexItem(i),
				onEnterBack: () => activateIndexItem(i),
				//markers:     true
			});
		});

		function activateIndexItem(i) {
			indexSidebarNavLinks.forEach((e) => {
				e.classList.remove("active");
			});

			indexSidebarNavLinks[i].classList.add("active");
		}
	}


	bindLinkToItem('.menu-item-has-children[data-mega-menu] > .sub-menu > li');


	/**
	 * Customize checkboxes in Hubspot forms
	 */
	window.addEventListener("message", event => {
		if (event.data.type === "hsFormCallback" && event.data.eventName === "onFormReady")
		{
			inputToToggle('.hbspt-form input[type="checkbox"]');

			const form = document.getElementById('hsForm_' + event.data.id);

			form.querySelectorAll('select').forEach(function (select) {
				const wrapper = document.createElement('div');
				wrapper.classList.add('select-wrapper');

				utils.wrap(select, wrapper);
			});

			ScrollTrigger.getAll().forEach(t => t.refresh());
		}
	});


	/**
	 * Popup assistenza in pagina Contatti
	 */
	const popupAssistenza = document.querySelector('.popup-assistenza');

	if (popupAssistenza)
	{
		setTimeout(function () {
			popupAssistenza.classList.add('active');
		}, 1500);

		popupAssistenza.querySelector('.popup-assistenza__close').addEventListener('click', function (e) {
			e.stopPropagation();
			popupAssistenza.classList.remove('active');
		});
	}


	/**
	 * Home animations
	 */
	if (document.body.classList.contains('home'))
	{
		mm.add("(min-width: 768px)", () => {

			ScrollTrigger.create({
				trigger: ".hero-home",
				start:   "top top",
				pin:     ".hero-home__title",
			});

		});

		ScrollTrigger.create({
			trigger: ".hero-home",
			start:   "top top",
			pin:     ".hero-home .media",
		});

		ScrollTrigger.create({
			trigger: ".section-1",
			start:   "top top",
			end:     '+=200%',
			pin:     true,
		});

		const section1Title = document.querySelector('.section-1__content .title');

		let text = section1Title.textContent;

		section1Title.innerHTML = text.replace(/[a-zA-Z0-9òàùèéì,;.!?(){}[\]:"'’<>-]/g, '<span>$&</span>');

		const spans = section1Title.querySelectorAll("span");

		gsap
			.timeline({
				scrollTrigger: {
					trigger:    ".hero-home",
					endTrigger: ".entry-content",
					scrub:      1,
					start:      "bottom 112px",
					end:        '+=100%',
					//markers: true
				}
			})
			.from(spans, {
				color:   '#3f3f3f',
				ease:    "none",
				stagger: 0.1
			});
	}


	/**
	 * Move navigation elements on desktop to build mega menus and on mobile to restore the default menus
	 */
	const adaptNavigation = function () {
		const header                  = document.getElementById('header');
		const approfondimentoProdotti = document.querySelector('.approfondimento-prodotti');
		const megaMenuSoluzioniIntro  = document.querySelector('.mega-menu-soluzioni__intro');

		// on desktop >= 1440px
		if (breakpointXl.matches)
		{
			// move mega menus after the header
			document.querySelectorAll('.menu-item-has-children[data-mega-menu]').forEach(function (menuItem) {
				const megaMenuName = menuItem.dataset.megaMenu;
				const subMenu      = menuItem.querySelector('.sub-menu');

				// create mega-menu nav item
				const megaMenu = document.createElement('nav');
				megaMenu.setAttribute('id', megaMenuName);
				megaMenu.classList.add('mega-menu');
				megaMenu.classList.add(megaMenuName);

				// append the submenu to the mega-menu
				megaMenu.append(subMenu);

				// insert the mega-menu after the header
				header.after(megaMenu);


				// move .approfondimento-prodotti inside .mega-menu-prodotti
				if (megaMenuName === 'mega-menu-prodotti')
				{
					const megaMenuProdotti = document.querySelector('.mega-menu-prodotti');
					megaMenuProdotti.append(approfondimentoProdotti);

					bindLinkToItem('.approfondimento-prodotti .menu-item');
				}

				// move .mega-menu-soluzioni__intro inside .mega-menu-soluzioni
				if (megaMenuName === 'mega-menu-soluzioni')
				{
					const megaMenuSoluzioni = document.querySelector('.mega-menu-soluzioni');
					megaMenuSoluzioni.prepend(megaMenuSoluzioniIntro);
				}

				const event = new CustomEvent('adaptNavigationToDesktop');
				window.dispatchEvent(event);
			});
		}
		// on mobile < 1440px
		else
		{
			// restore .mega-menu's .sub-menu items to their original .menu-item in .main-navigation__menu
			document.querySelectorAll('.mega-menu').forEach(function (megaMenu) {
				const subMenu             = megaMenu.querySelector('.sub-menu');
				const originalNavMenuItem = document.querySelector('.main-navigation__menu .menu-item-has-children[data-mega-menu="' + megaMenu.id + '"]');

				if (subMenu !== null && originalNavMenuItem !== null)
				{
					originalNavMenuItem.append(subMenu);

					megaMenu.remove();
				}
			});

			document.querySelector('.menu-item-has-children[data-mega-menu="mega-menu-prodotti"] .sub-menu').append(approfondimentoProdotti);
			document.querySelector('.menu-item-has-children[data-mega-menu="mega-menu-soluzioni"] .sub-menu .close-sub-menu').after(megaMenuSoluzioniIntro);

			const event = new CustomEvent('adaptNavigationToMobile');
			window.dispatchEvent(event);
		}
	};

	breakpointXl.addEventListener('change', adaptNavigation);
	adaptNavigation();


	/**
	 * Move .swiper-nav after .swiper when < 992px, restore its position when >= 992px
	 */
	const swiperNavs = document.querySelectorAll('.module-slideshow .swiper-nav,.module-slideshow-referenze .swiper-nav, .module-slideshow-video .swiper-nav, .module-slideshow-articoli .swiper-nav, .module-slideshow-cards .swiper-nav, .module-slideshow-prodotti .swiper-nav');

	swiperNavs.forEach(swiperNav => {

		const section     = swiperNav.closest('section');
		swiperNav._swiper = section.querySelector('.swiper');

		swiperNav._placeholder = document.createComment('swiper-nav-original-position');
		swiperNav.before(swiperNav._placeholder);

	});

	function moveSwiperNavOnMobile() {
		swiperNavs.forEach(swiperNav => {
			if (breakpointLg.matches)
			{
				swiperNav._placeholder.before(swiperNav);
			}
			else
			{
				swiperNav._swiper.after(swiperNav);
			}
		});
	}

	breakpointLg.addEventListener('change', moveSwiperNavOnMobile);
	moveSwiperNavOnMobile();


	/**
	 * Move the "Cerca" search menu item just before #menu-toggle when < 1440px,
	 * restore its original position in the nav menu otherwise
	 */
	const searchMenuItem = document.querySelector('.open-popup-search');

	if (searchMenuItem)
	{
		searchMenuItem._placeholder = document.createComment('search-menu-item-original-position');
		searchMenuItem.before(searchMenuItem._placeholder);
	}

	function moveSearchMenuItem() {
		if (!searchMenuItem)
		{
			return;
		}

		if (!breakpointXl.matches)
		{
			document.getElementById('menu-toggle').before(searchMenuItem);
		}
		else
		{
			searchMenuItem._placeholder.before(searchMenuItem);
		}
	}

	breakpointXl.addEventListener('change', moveSearchMenuItem);
	moveSearchMenuItem();


	/**
	 * Turn the footer widgets into accordions on mobile
	 * @type {NodeListOf<Element>}
	 */
	const footerAccordionToggles = document.querySelectorAll('.accordion-on-mobile .widget-title');

	footerAccordionToggles.forEach(function (toggle) {
		toggle.addEventListener('click', function () {
			if (!breakpointLg.matches)
			{
				utils.slideToggle(toggle.nextElementSibling);
				utils.toggleClasses(toggle, 'active');
			}
		});
	});


	/**
	 * Wrap .btn content with <span class="btn__label"></span>, if .btn__label is missing
	 */
	document.querySelectorAll('.module-testo .btn, .editor-content .btn').forEach(link => {

		if (link.querySelector('.btn__label'))
		{
			return;
		}

		link.childNodes.forEach(node => {
			if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== '')
			{
				const span     = document.createElement('span');
				span.className = 'btn__label';

				span.textContent = node.textContent;

				link.replaceChild(span, node);
			}
		});

	});

}); // END ready



/**
 * ON LOAD
 */

window.addEventListener('load', function (event) {

	ScrollTrigger.getAll().forEach(t => t.refresh());

});



/**
 * ON RESIZE
 */
window.addEventListener('resize', function (event) {

});


/**
 * ON RESIZE END
 */

// do something when the window resizing ends
window.addEventListener('resizeEnd', function () {

});

window.addEventListener('resizeHorizontallyEnd', function () {

	ScrollTrigger.getAll().forEach(t => t.refresh());

});


/**
 * ON SCROLL
 */
/*window.addEventListener('scroll', function() {
});*/